import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    Inject,
    OnInit,
    QueryList,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ChangeHistory, Student, StudentAddComment} from '../../shared/interface/roster.interface';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {RosterService} from '../../shared/roster.service';
import {AlertService} from '../../shared/services/alert.service';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';

@Component({
    selector: 'app-roster-roster-view-grade-change',
    templateUrl: './roster-view-grade-change.component.html',
    styleUrls: ['./roster-view-grade-change.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class RosterViewGradeChangeComponent implements OnInit, AfterViewInit {
    constructor(
        public dialogRef: MatDialogRef<RosterViewGradeChangeComponent>,
        public rosterService: RosterService,
        private alert: AlertService,
        @Inject(MAT_DIALOG_DATA) public data: Student,
        private changeDetectorRef: ChangeDetectorRef
    ) {
    }

    displayedColumns: string[] = ['oldGrade', 'newGrade', 'submitDate', 'submittedBy'];
    changeHistoryList: ChangeHistory[] = [];
    pagingSizeList: number[] = [];
    numPerPage: number = 20;

    @ViewChild(MatTable) table: MatTable<ChangeHistory[]>;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    public dataSource: MatTableDataSource<ChangeHistory>;


    //local variables that is needed
    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.setDataSource();
        this.changeDetectorRef.detectChanges();
    }


    getPagingSize(totalNumRecords: number): number[] {
        const returnPagingSizeList: number[] = [];
        if (totalNumRecords > this.numPerPage) {
            for (let i = 1; i < totalNumRecords; i++) {
                if (i % this.numPerPage === 0) {
                    returnPagingSizeList.push(i);
                }
            }
        }

        returnPagingSizeList.push(totalNumRecords);

        return returnPagingSizeList.filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => a - b);
    }

    setDataSource() {
        const paginatorBox: HTMLElement = document.getElementById('gradeChangeHistoryPaginator');

        this.changeHistoryList = [];

        this.data.changeHistoryLog.forEach((log: string) => {
            const tempArray = log.split('|');
            const tempChangeHistory: ChangeHistory = {
                oldGrade: null,
                newGrade: null,
                submitDate: null,
                submittedBy: null
            };

            tempChangeHistory.oldGrade = tempArray[0];
            tempChangeHistory.newGrade = tempArray[1];
            tempChangeHistory.submitDate = tempArray[2];
            tempChangeHistory.submittedBy = tempArray[3];
            this.changeHistoryList.push(tempChangeHistory);
        });

        //set show or not show

        this.changeHistoryList.sort(function (a, b) {
            return a.submitDate > b.submitDate ? -1 : 1
        });

        this.dataSource = new MatTableDataSource<ChangeHistory>(this.changeHistoryList);

        this.dataSource.sort = this.sort;
        if (this.changeHistoryList.length > this.numPerPage) {
            paginatorBox.classList.remove('do-not-show');
            this.pagingSizeList = this.getPagingSize(this.changeHistoryList.length);
            this.paginator.pageSizeOptions = this.pagingSizeList;
            this.paginator.pageSize = this.changeHistoryList.length > this.numPerPage ? this.numPerPage : this.changeHistoryList.length;
            this.dataSource.paginator = this.paginator;
            this.table.renderRows();
        } else {
            paginatorBox.classList.add('do-not-show');
        }


    }


    onClose() {
        this.dialogRef.close(this.data);
    }
}
